"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaObject = void 0;
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const CreativeWork_1 = require("./CreativeWork");
const schema_1 = require("../ontologies/schema");
const Server_1 = require("lincd-server-utils/lib/utils/Server");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const xsd_1 = require("lincd-xsd/lib/ontologies/xsd");
let MediaObject = class MediaObject extends CreativeWork_1.CreativeWork {
    get contentUrl() {
        return this.getValue(schema_1.schema.contentUrl);
    }
    set contentUrl(val) {
        this.overwrite(schema_1.schema.contentUrl, new models_1.Literal(val));
    }
    get url() {
        return this.getValue(schema_1.schema.url);
    }
    set url(val) {
        this.overwrite(schema_1.schema.url, new models_1.Literal(val));
    }
    get dateCreated() {
        return this.getValue(schema_1.schema.dateCreated);
    }
    set dateCreated(val) {
        this.overwrite(schema_1.schema.dateCreated, new models_1.Literal(val));
    }
    get identifier() {
        return parseInt(this.getValue(schema_1.schema.identifier));
    }
    set identifier(val) {
        this.overwrite(schema_1.schema.actionStatus, new models_1.Literal(val.toString(), xsd_1.xsd.integer));
    }
    static deleteFile(filePath) {
        return Server_1.Server.call(this, 'deleteFile', filePath);
    }
    static fromFormFiles(files) {
        var formData = new FormData();
        for (var key in files) {
            if (files.hasOwnProperty(key)) {
                formData.append('upload-' + key, files[key], files[key].name);
            }
        }
        return null;
        //content-type needs to specifically be left UNDEFINED
        //https://stackoverflow.com/questions/39280438/fetch-missing-boundary-in-multipart-form-data-post
        // var headers = {
        //   Accept: 'application/json, text/plain, */*',
        // };
        //
        // return Server.call(new MediaObject(), {
        //   method:'fromFormFiles',
        //   headers
        // }, formData) as Promise<ShapeSet<MediaObject>>;
        // return Server.call(MediaObject, 'fromFormFiles', formData) as Promise<MediaObject>;
    }
};
MediaObject.targetClass = schema_1.schema.MediaObject;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.contentUrl,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], MediaObject.prototype, "contentUrl", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.url,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], MediaObject.prototype, "url", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.dateCreated,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], MediaObject.prototype, "dateCreated", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.identifier,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], MediaObject.prototype, "identifier", null);
MediaObject = __decorate([
    package_1.linkedShape
], MediaObject);
exports.MediaObject = MediaObject;
//# sourceMappingURL=MediaObject.js.map